<!-- src/app/settings/accruals/pages/leave-transactions/leave-transactions.component.html -->
<accruals-nav></accruals-nav>

<div class="leave-transactions-container">
  <!-- Loading -->
  <div *ngIf="isLoading" class="spinner-container">
    <div class="spinner"></div>
  </div>

  <!-- Error -->
  <div *ngIf="errorMessage && !isLoading" class="error-message">
    {{ errorMessage }}
  </div>

  <ng-container *ngIf="!isLoading">
    <!-- Header -->
    <div class="header">
      <h2>Leave Transactions</h2>
    </div>

    <!-- Filters -->
    <div class="filters-container">
      <div class="filters-row">
        <label class="filter-field search-field">
          <span>Search</span>
          <input type="text" [(ngModel)]="searchInputValue" (ngModelChange)="onSearchTermChange($event)"
            placeholder="Search employee, entry type, reference, or leave type" />
        </label>

        <label class="filter-field">
          <span>Leave Type</span>
          <select [ngModel]="filters.leaveType" (ngModelChange)="onLeaveTypeChange($event)">
            <option [ngValue]="null">All leave types</option>
            <option *ngFor="let type of leavePolicyFilterValues?.leaveTypes" [ngValue]="type">
              {{ type }}
            </option>
          </select>
        </label>

        <label class="filter-field">
          <span>Entry Type</span>
          <select [ngModel]="filters.entryType" (ngModelChange)="onEntryTypeChange($event)">
            <option [ngValue]="null">All entry types</option>
            <option *ngFor="let type of entryTypes" [ngValue]="type">
              {{ type }}
            </option>
          </select>
        </label>

        <label class="filter-field">
          <span>Start Date</span>
          <input type="date" [ngModel]="filters.startDate" (ngModelChange)="onStartDateChange($event)" />
        </label>

        <div class="filter-actions">
          <button class="clear-filters-btn" type="button" (click)="clearFilters()" [disabled]="!hasActiveFilters">
            Clear Filters
          </button>
        </div>
      </div>
    </div>

    <!-- Sticky Pagination -->
    <div class="pagination sticky">
      <div class="page-controls">
        <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">
          Prev
        </button>

        <span>Page {{ currentPage }} of {{ totalPages }}</span>

        <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">
          Next
        </button>
      </div>

      <div class="page-size">
        <label for="pageSize">Page Size:</label>
        <select id="pageSize" [(ngModel)]="pageSize" (change)="changePageSize(pageSize)">
          <option *ngFor="let size of pageSizes" [value]="size">{{ size }}</option>
        </select>
      </div>
    </div>


    <!-- Transactions List -->
    <div class="transactions-list" *ngIf="filteredTransactions.length > 0; else noTransactions">
      <div *ngFor="let transaction of pagedTransactions; trackBy: trackByTransactionId" class="transaction-row"
        [ngClass]="getLeaveTypeClass(transaction.leaveType)">
        <div class="transaction-main">
          <div class="transaction-top-row">
            <div class="transaction-top-left">
              <div class="employee-name">
                {{ transaction.employee.firstName }} {{ transaction.employee.lastName }}
              </div>

              <div class="badges">
                <span class="employee-number-badge">
                  #{{ transaction.employee.employeeNumber }}
                </span>

                <span class="leave-type-badge" [ngClass]="getLeaveTypeClass(transaction.leaveType)">
                  {{ transaction.leaveType }}
                </span>

                <span class="entry-type-badge" [ngClass]="getEntryTypeClass(transaction.entryType)">
                  {{ transaction.entryType }}
                </span>
              </div>
            </div>

            <div class="transaction-impact-card"
              [ngClass]="[getLeaveTypeClass(transaction.leaveType), getHoursClass(transaction.hours)]">
              <div class="impact-label">
                {{ transaction.leaveType }} Time {{ transaction.hours >= 0 ? 'Gained' : 'Used' }}
              </div>
              <div class="impact-value">
                {{ transaction.hours > 0 ? '+' : '' }}{{ transaction.hours }}
              </div>
            </div>
          </div>

          <div class="transaction-meta">
            <span>Effective Date: {{ transaction.effectiveDate }}</span>
            <span *ngIf="transaction.referenceId">Reference: {{ transaction.referenceId }}</span>
          </div>
        </div>
      </div>
    </div>

    <ng-template #noTransactions>
      <div class="empty-state">
        No transactions match the current filters.
      </div>
    </ng-template>
  </ng-container>
</div>